import React from 'react';
import DeletionQueuePanel from '../../components/admin/DeletionQueuePanel.jsx';

/**
 * Phone deletion queue management page for admin interface
 */
const PhoneDeletionQueue = () => {
  return <DeletionQueuePanel />;
};

export default PhoneDeletionQueue;
